import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, Grid, Link } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { LLS_HOME_URL, TELEPERFORMANCE_PRIVACY_URL } from "../../config/urls";
import { useLltsBranch } from "../../hooks/useLltsBranch";

const Footer: FC = () => {
  const { t } = useTranslation();
  const branch = useLltsBranch();

  return (
    <footer>
      <Box
        sx={{
          background: "#002b50",
          color: "#fff",
          fontSize: 14,
          padding: "19px 0",
          "& a": {
            color: "#fff",
            textDecoration: "underline"
          },
          "& a:focus-visible": {
            outline: "2px solid #fff",
            outlineOffset: "2px",
            borderRadius: "2px"
          }
        }}
      >
        <Box mx={5}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={6}>
              <Box
                dangerouslySetInnerHTML={{
                  __html: t("footer.copyright", {
                    teleperformancePrivacy: TELEPERFORMANCE_PRIVACY_URL,
                    llsDotCom: branch?.websiteUrl ? branch.websiteUrl : LLS_HOME_URL,
                    fullYear: new Date().getFullYear()
                  })
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: { xs: "flex-start", md: "flex-end" },
                  columnGap: 3,
                  rowGap: 1
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0, overflowWrap: "anywhere" }}>
                  <EmailIcon fontSize="small" />
                  <Link href={`mailto:${branch?.supportEmail || t("footer.contact.email")}`} underline="hover">
                    {branch?.supportEmail || t("footer.contact.email")}
                  </Link>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <PhoneIcon fontSize="small" />
                  <Link
                    href={`tel:${branch?.phoneNumber || t("footer.contact.phone").replace(/[^0-9]/g, "")}`}
                    underline="hover"
                    aria-label={t("footer.contact.phoneLabel", {
                      phone: branch?.phoneNumber || t("footer.contact.phone")
                    })}
                  >
                    {branch?.phoneNumber || t("footer.contact.phone")}
                  </Link>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </footer>
  );
};

export default Footer;
